module.exports = __webpack_public_path__ + "static/media/vedseeds.bfd122aa.png";